// src/components/Layout.js
import React from 'react';
import { useMediaQuery } from '@mui/material';
import DesktopLayout from '../DesktopLayout'; // Your existing layout component
import MobileLayout from '../MobileLayout';
import theme from '../../theme';

const Layout = ({ children }) => {
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return isMobile ? <MobileLayout>{children}</MobileLayout> : <DesktopLayout>{children}</DesktopLayout>;
};

export default Layout;
